export class Partner{
    partnerID: number;
    partnerName: string;
    logoImageContentType: string;
    partnerDescription: string;
    partnerTierID: number;
    logo: string;
    headerMessage: string;
    token: string;
}